<div
  class="workflow-finx-multiselect"
  [ngClass]="{ 'is-search-active': isSearchActive, 'is-vertical-aligned': isVerticalAligned }"
>
  @if (label) {
    <label [for]="formControlName" class="mb-2">{{ label }}</label>
  }
  <p-multiSelect
    [id]="id"
    [styleClass]="'w-100'"
    [options]="options"
    [optionLabel]="optionLabel"
    [optionValue]="optionValue"
    [optionDisabled]="optionDisabled"
    [formControl]="inputStringControl"
    [showToggleAll]="true"
    [appendTo]="appendto"
    [group]="isGroup"
    (onChange)="onChange($event)"
    [name]="formControlName"
    [ngModel]="value"
    ngDefaultControl
    [placeholder]="defaultLabel"
    [selectionLimit]="selectionLimit"
  >
    <ng-template let-group pTemplate="group">
      <div class="flex align-items-center">
        <b>{{ group.label }}</b>
      </div>
    </ng-template>
  </p-multiSelect>
</div>
